/* eslint-disable no-console */
import { client } from "."; // ← cliente oficial de Supabase (supabase.js, NO tocar — 10.8)

// Lectura/escritura AISLADA de los vínculos contacto ↔ clientes (tabla puente
// usuarios_clientes, Fase 1 del scope multi-cliente del reporte fotográfico).
//
// NO toca usuarios.cliente_id (escalar, lo usan los contactos rol='cliente') ni ninguna
// otra columna de usuarios. NO reusa updateUsuario (que escribe email incondicional).
// Todo por ID (10.7). Sin fallo silencioso (10.170 / 10.177): ante error se loguea y se
// devuelve { data: null, error } — nunca se enmascara a "sin clientes" ([]).

// Devuelve los cliente_id vinculados a un contacto como array de Number.
// { data: number[] | null, error }. data=[] = contacto sin vínculos (estado real, no error).
export const getUsuarioClientes = async (usuarioId) => {
  const id = Number(usuarioId);
  if (!id) {
    return { data: null, error: new Error("getUsuarioClientes: usuarioId inválido") };
  }

  const { data, error } = await client.from("usuarios_clientes").select("cliente_id").eq("usuario_id", id);

  if (error) {
    console.error("Error en getUsuarioClientes:", error);
    return { data: null, error };
  }

  return { data: (data || []).map((r) => Number(r.cliente_id)), error: null };
};

// Reconcilia el set de clientes vinculados de un contacto a `clienteIds` (array de ids).
// Diff (inserta faltantes, borra sobrantes) en vez de borrar-todo-y-reinsertar: así un
// fallo a mitad no deja al contacto sin ningún vínculo. `createdBy` = ID real del usuario
// que vincula (10.104), se graba solo en las filas nuevas.
// { data: number[] | null, error } — data = estado final (lectura fresca) o null si algo falló.
export const setUsuarioClientes = async (usuarioId, clienteIds, createdBy) => {
  const id = Number(usuarioId);
  if (!id) {
    return { data: null, error: new Error("setUsuarioClientes: usuarioId inválido") };
  }

  // Normalizar a Set de Number (sin nulls ni duplicados) — comparación por ID (10.7).
  const deseados = new Set((clienteIds || []).map(Number).filter(Boolean));

  // Estado actual en la tabla puente.
  const { data: actualesData, error: readErr } = await client
    .from("usuarios_clientes")
    .select("cliente_id")
    .eq("usuario_id", id);
  if (readErr) {
    console.error("Error en setUsuarioClientes (lectura previa):", readErr);
    return { data: null, error: readErr };
  }
  const actuales = new Set((actualesData || []).map((r) => Number(r.cliente_id)));

  const aInsertar = [...deseados].filter((c) => !actuales.has(c));
  const aBorrar = [...actuales].filter((c) => !deseados.has(c));

  // Insertar los faltantes.
  if (aInsertar.length > 0) {
    const filas = aInsertar.map((cliente_id) => ({
      usuario_id: id,
      cliente_id,
      created_by: createdBy ? Number(createdBy) : null,
    }));
    const { error: insErr } = await client.from("usuarios_clientes").insert(filas);
    if (insErr) {
      console.error("Error en setUsuarioClientes (insert):", insErr);
      return { data: null, error: insErr };
    }
  }

  // Borrar los sobrantes (acotado a este usuario y a los ids a quitar).
  if (aBorrar.length > 0) {
    const { error: delErr } = await client
      .from("usuarios_clientes")
      .delete()
      .eq("usuario_id", id)
      .in("cliente_id", aBorrar);
    if (delErr) {
      console.error("Error en setUsuarioClientes (delete):", delErr);
      return { data: null, error: delErr };
    }
  }

  // Estado final confirmado por lectura fresca (no asumir el resultado del write — 10.177).
  return await getUsuarioClientes(id);
};
